module.exports = __webpack_public_path__ + "media/images/flags/gd-96d7ac530243f8faab5b62c6e04fa290.svg";